import family1 from '../images/family1.jpeg';
import family2 from '../images/family2.jpeg';
import family3 from '../images/family3.jpeg';
import family4 from '../images/family4.jpeg';
import family5 from '../images/family5.jpeg';
import family6 from '../images/family6.jpeg';
import family7 from '../images/family7.jpeg';
import family8 from '../images/family8.jpeg';
import family9 from '../images/family9.jpeg';
import family10 from '../images/family10.jpeg';

const familyArray = () => {
  return [
    family1,
    family10,
    family2,
    family5,
    family3,
    family4,
    family6,
    family7,
    family8,
    family9,
  ];
};

export default familyArray();
